import { render, staticRenderFns } from "./PerfilView.vue?vue&type=template&id=30e03f81&"
import script from "./PerfilView.vue?vue&type=script&lang=js&"
export * from "./PerfilView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports